var SimpleLightbox = require('simple-lightbox');
import 'simple-lightbox/dist/simpleLightbox.css';

export const initBlockGallery = () => {
    document.addEventListener('DOMContentLoaded', function () {
        const blocks = document.querySelectorAll('.blockGallery');

        if (blocks) {
            blocks.forEach(block => {
                var lightbox = new SimpleLightbox({
                    elements: '.lightBoxRun'
                });
            })
        }
    })
};